import React from "react";
import { Link, withRouter } from "react-router-dom";
import Helper from "../../Helper/helper";
import api from "../../../Environment";
import { withToastManager } from "react-toast-notifications";
import ToastDemo, { notifyShellLoadError } from "../../Helper/toaster";
import configuration from "react-global-configuration";

import { translate } from "react-multi-lang";
import {
  getHeaderActions,
  isExternalHref,
} from "../../Helper/siteContent";
import { resolveBrandLinkIconClass } from "../../Helper/brandLinks";
import { normalizeExternalUrl } from "../../Helper/urls";
import {
  fetchMainNavigation,
  mainNavigationItems,
  isExternalNavRoute,
} from "../../Navigation/navigationApi";
import { fetchStudioCapabilities, openPlatformPortal } from "../../Helper/studioCapabilities";
import NotificationBell from "../../Notifications/NotificationBell";
import UniversalCastButton from "./UniversalCastButton";
import { searchAutocomplete } from "../../Search/unifiedSearchApi";
import "./UserHeader.css";

class UserHeader extends Helper {
  constructor(props) {
    super(props);
  }
  state = {
    loading: true,
    activeProfile: null,
    loadingMainNav: true,
    mainNavigation: null,
    playButtonClicked: false,
    value: "",
    suggestions: [],
    mobileSidebar: false,
    loadingSuggesstion: false,
    displaySuggesstion: "none",
    searchInputFocusClass: "",
    canAccessStudio: false,
    platformPortals: [],
  };

  componentDidMount() {
    // Do not set .header-height — .main-sec-content already has margin-top
    // clearance under the sticky nav (Home/Shop/Org/Creator share this).
    // Setting spacer height here double-offsets Org/Creator and creates a gap.
    // Deploy fingerprint — prefer stamped window.__TPG_BUILD__ from index.html.
    if (typeof window !== "undefined" && window.console) {
      const stamp =
        window.__TPG_BUILD__ || {
          commit: "unstamped",
          mainChunk: "unknown",
        };
      window.console.info("[TPG] UserHeader mount", stamp);
    }

    const hasSession =
      localStorage.getItem("userId") && localStorage.getItem("accessToken");

    // Public org/creator/project landings use UserLayout without login.
    // Never call authenticated profile APIs anonymously — empty id/token
    // yields error_code 3000 and can bounce visitors to /login.
    if (hasSession) {
      this.viewProfiles();
    } else {
      this.setState({ loading: false, activeProfile: [] });
    }

    if (hasSession) {
      fetchStudioCapabilities().then((caps) => {
        if (typeof window !== "undefined" && window.console) {
          window.console.info("[TPG] studio/actor portals", {
            error: !!(caps && caps.error),
            roles: caps && caps.platform_roles,
            portals: caps && caps.portals,
          });
        }
        this.setState({
          canAccessStudio: !!(caps && caps.can_access_studio && !caps.error),
          platformPortals:
            caps && Array.isArray(caps.portals) && !caps.error
              ? caps.portals
              : [],
        });
      });
    }

    // A-009A.4 — Main navigation from canonical payload (Browse + Community children included)
    fetchMainNavigation()
      .then((payload) => {
        this.setState({
          loadingMainNav: false,
          mainNavigation: payload,
        });
        if (payload && payload.loadError) {
          notifyShellLoadError(this.props.toastManager, "header_nav");
        }
      })
      .catch(() => {
        this.setState({
          loadingMainNav: false,
          mainNavigation: null,
        });
        notifyShellLoadError(this.props.toastManager, "header_nav");
      });
    // Notifications: NotificationBell + notificationCenterApi only (no legacy notifications fetch).
  }

  openPortal = (portal, event) => {
    if (event) {
      event.preventDefault();
    }
    if (!portal) {
      return;
    }

    // Blade staff portals: workspace selection IS the handoff (no intermediate page).
    if (portal.kind === "blade" || portal.requires_handoff) {
      openPlatformPortal(portal);
      return;
    }

    const key = String(portal.key || portal.role || "").toLowerCase();
    let workspacePath = null;
    if (key === "creator") {
      const entities = Array.isArray(portal.entities) ? portal.entities : [];
      if (entities.length > 1) {
        workspacePath = "/workspace/creator";
      } else {
        workspacePath =
          entities.length === 1
            ? "/workspace/creator/" + entities[0].id
            : "/workspace/creator";
      }
    } else if (key === "organization") {
      const entities = Array.isArray(portal.entities) ? portal.entities : [];
      workspacePath =
        entities.length === 1
          ? "/workspace/organization/" + entities[0].id
          : "/workspace/organization";
    } else if (key === "project_manager" || key === "project") {
      const entities = Array.isArray(portal.entities) ? portal.entities : [];
      workspacePath =
        entities.length === 1
          ? "/workspace/project/" + entities[0].id
          : "/workspace/project";
    }

    if (workspacePath && this.props.history) {
      this.props.history.push(workspacePath);
      return;
    }

    const path = portal.path || "/workspace";
    if (this.props.history && path.startsWith("/")) {
      this.props.history.push(path);
      return;
    }
    openPlatformPortal(portal);
  };

  renderWorkspaceMenuItems = () => {
    const portals = Array.isArray(this.state.platformPortals)
      ? this.state.platformPortals
      : [];
    if (!portals.length) {
      return [];
    }

    const activeId = (() => {
      try {
        const raw = localStorage.getItem("tpg_active_workspace");
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed && parsed.workspaceId ? parsed.workspaceId : null;
      } catch (e) {
        return null;
      }
    })();

    // Role/portal-backed workspaces only — no generic "Personal" workspace.
    const items = [];

    portals.forEach((portal) => {
      const key = String(portal.key || portal.role || "").toLowerCase();
      let wsId = null;
      if (key === "creator") wsId = "creator";
      else if (key === "organization") wsId = "organization";
      else if (key === "project_manager" || key === "project") wsId = "project";
      else if (key === "sales_representative" || key === "sales_rep")
        wsId = "sales";
      else if (key === "moderator") wsId = "moderator";
      else if (
        key === "sub_admin" ||
        key === "administrator" ||
        key === "admin"
      )
        wsId = "subadmin";
      const isCurrent = activeId && wsId && activeId === wsId;
      items.push(
        <a
          key={portal.key || portal.role || portal.label}
          className={"dropdown-item ws-menu-item" + (isCurrent ? " is-current" : "")}
          href={portal.path || "#"}
          onClick={(e) => this.openPortal(portal, e)}
        >
          <span className="ws-menu-item__label">
            {portal.label || portal.role}
          </span>
        </a>
      );
    });

    return items;
  };

  handleSearchChange = ({ currentTarget: input }) => {
    const nextValue = input.value || "";
    this.setState({ value: nextValue });
    if (nextValue !== "") {
      this.setState({ displaySuggesstion: "block", loadingSuggesstion: true });
    } else {
      this.setState({
        displaySuggesstion: "none",
        searchInputFocusClass: "",
        suggestions: [],
        loadingSuggesstion: false,
      });
      return;
    }
    searchAutocomplete(nextValue)
      .then((suggestionsRaw) => {
        const suggestions = (Array.isArray(suggestionsRaw) ? suggestionsRaw : []).map(
          (s, idx) => {
            const discoveryUrl =
              (typeof s.detail_route === "string" && s.detail_route.startsWith("/")
                ? s.detail_route
                : null) ||
              (typeof s.url === "string" && s.url.startsWith("/") ? s.url : null);
            return {
              id: s.id || `ac-${idx}`,
              title: s.label || s.title || "",
              url:
                discoveryUrl ||
                `/search?q=${encodeURIComponent(s.label || s.title || "")}`,
              index: s.index,
              content_type: s.content_type || s.index,
            };
          }
        );
        this.setState({
          suggestions,
          loadingSuggesstion: false,
          searchInputFocusClass: suggestions.length ? "search-focus" : "",
        });
      })
      .catch(() => {
        this.setState({
          suggestions: [],
          loadingSuggesstion: false,
        });
        // Typing autocomplete failures stay quiet — avoid toast spam per keystroke.
      });
  };

  searchInputFocus = ({ currentTarget: input }) => {
    this.setState({ searchInputFocusClass: "search-focus" });
  };

  handleOnSubmit = (event, value) => {
    event.preventDefault();
    const q = (value || this.state.value || "").trim();
    if (q) {
      this.props.history.push(`/search?q=${encodeURIComponent(q)}`);
      this.setState({ displaySuggesstion: "none", suggestions: [] });
    }
  };

  /** Unified Search suggestion click — prefer discovery URL over legacy video playback. */
  handleSuggestionClick = (event, suggestion) => {
    event.preventDefault();
    const url = suggestion && suggestion.url;
    if (url && typeof url === "string") {
      if (this.props.history && url.startsWith("/")) {
        this.props.history.push(url);
      } else {
        window.location = url;
      }
      this.setState({ displaySuggesstion: "none", suggestions: [], value: "" });
      return;
    }
    this.handlePlayVideo(event, suggestion);
  };

  changeProfile = (profile, event) => {
    event.preventDefault();

    localStorage.removeItem("active_profile_id");
    localStorage.setItem("active_profile_id", profile.sub_profile_id);
    localStorage.setItem("active_profile_image", profile.picture);
    localStorage.setItem("active_profile_name", profile.name);

    window.location = "/home";
  };

  handlePlayVideo = async (event, suggestion) => {
    event.preventDefault();

    const type = String(
      (suggestion && typeof suggestion === "object" && suggestion.content_type) ||
        "video"
    ).toLowerCase();

    if (type === "channel") {
      const path =
        suggestion.detail_route ||
        "/channels/" +
          (suggestion.slug || suggestion.unique_id || suggestion.channel_id);
      if (this.props.history) {
        this.props.history.push(path);
      } else {
        window.location = path;
      }
      return;
    }

    if (
      type !== "video" &&
      suggestion &&
      typeof suggestion === "object" &&
      suggestion.detail_route
    ) {
      if (this.props.history) {
        this.props.history.push(suggestion.detail_route);
      } else {
        window.location = suggestion.detail_route;
      }
      return;
    }

    const admin_video_id =
      typeof suggestion === "object"
        ? suggestion.admin_video_id || suggestion.contentable_id
        : suggestion;

    let inputData = {
      admin_video_id: admin_video_id,
    };

    var details = await this.onlySingleVideoFirst(inputData);

    if (!details) {
      ToastDemo(
        this.props.toastManager,
        (this.state.videoDetailsError &&
          this.state.videoDetailsError.error_messages) ||
          "Unable to start playback",
        "error"
      );
    } else {
      this.redirectStatus(details);
      this.setState({ playButtonClicked: true });
    }
  };

  renderList = (activeProfile) => {
    return (
      <div>
        {activeProfile.map((profile) =>
          profile.sub_profile_id ==
          localStorage.getItem("active_profile_id") ? (
            ""
          ) : (
            <Link
              className="dropdown-item"
              key={profile.sub_profile_id}
              to="/view-profiles"
              onClick={(event) => this.changeProfile(profile, event)}
            >
              <div className="display-inline">
                <div className="left-sec">
                  <img src={profile.picture} alt="profile_img" />
                </div>
                <div className="right-name">{profile.name}</div>
              </div>
            </Link>
          )
        )}
      </div>
    );
  };

  toggleMobileSidebar = () => {
    this.setState({
      mobileSidebar: !this.state.mobileSidebar,
    });
  };

  mobileHeader = (section, event) => {
    event.preventDefault();
    this.toggleMobileSidebar();
    if (!section || section === "#") {
      return;
    }
    if (isExternalNavRoute(section) || isExternalHref(section)) {
      window.location.assign(normalizeExternalUrl(section));
      return;
    }
    if (this.props.history && typeof this.props.history.push === "function") {
      this.props.history.push(section);
      return;
    }
    window.location.assign(section);
  };

  /**
   * A-009A.4 — Render one main_navigation item (desktop).
   */
  renderDesktopNavItem = (item) => {
    if (!item || item.visible === false) {
      return null;
    }
    const key = `nav-${item.slug || item.id}`;
    const children = Array.isArray(item.children) ? item.children : [];
    const isDropdown =
      item.type === "dropdown" || children.length > 0;

    if (isDropdown) {
      if (!children.length) {
        return null;
      }
      return (
        <li className="nav-item dropdown" key={key}>
          <Link
            className="nav-link dropdown-toggle"
            data-toggle="dropdown"
            to="#"
          >
            {item.title}
          </Link>
          <div className="dropdown-menu browse">
            {children.map((child, index) =>
              this.renderNavLink(child, {
                className: "dropdown-item",
                key: `nav-child-${item.slug}-${child.slug || index}`,
              })
            )}
          </div>
        </li>
      );
    }

    return (
      <li className="nav-item" key={key}>
        {this.renderNavLink(item, { className: "nav-link" })}
      </li>
    );
  };

  /**
   * A-009A.4 — Render one main_navigation item (mobile sidebar).
   */
  renderMobileNavItem = (item) => {
    if (!item || item.visible === false) {
      return null;
    }
    const key = `nav-mobile-${item.slug || item.id}`;
    const children = Array.isArray(item.children) ? item.children : [];
    const isDropdown =
      item.type === "dropdown" || children.length > 0;

    if (isDropdown) {
      if (!children.length) {
        return null;
      }
      return (
        <li className="dropdown" key={key}>
          <Link className="dropdown-toggle" data-toggle="dropdown" to="#">
            {item.title}{" "}
          </Link>
          <div className="dropdown-menu browse">
            {children.map((child, index) => {
              const childRoute = child.route || "#";
              if (
                isExternalNavRoute(childRoute) ||
                isExternalHref(childRoute)
              ) {
                return (
                  <a
                    key={`nav-mobile-child-${item.slug}-${child.slug || index}`}
                    className="dropdown-item"
                    href={normalizeExternalUrl(childRoute)}
                    target={child.new_tab ? "_blank" : undefined}
                    rel={child.new_tab ? "noopener noreferrer" : undefined}
                    onClick={() => this.toggleMobileSidebar()}
                  >
                    {child.title}
                  </a>
                );
              }
              return (
                <Link
                  key={`nav-mobile-child-${item.slug}-${child.slug || index}`}
                  className="dropdown-item"
                  to={childRoute}
                  onClick={() => this.toggleMobileSidebar()}
                >
                  {child.title}
                </Link>
              );
            })}
          </div>
        </li>
      );
    }

    const route = item.route || "#";
    if (isExternalNavRoute(route) || isExternalHref(route)) {
      return (
        <li key={key}>
          <a
            href={normalizeExternalUrl(route)}
            target={item.new_tab ? "_blank" : undefined}
            rel={item.new_tab ? "noopener noreferrer" : undefined}
            onClick={() => this.toggleMobileSidebar()}
          >
            {item.title}
          </a>
        </li>
      );
    }

    return (
      <li key={key}>
        <Link to={route} onClick={() => this.toggleMobileSidebar()}>
          {item.title}
        </Link>
      </li>
    );
  };

  renderNavLink = (item, { className, key } = {}) => {
    const route = (item && item.route) || "#";
    const title = (item && item.title) || "";
    if (isExternalNavRoute(route) || isExternalHref(route)) {
      return (
        <a
          key={key}
          className={className}
          href={normalizeExternalUrl(route)}
          target={item.new_tab ? "_blank" : undefined}
          rel={item.new_tab ? "noopener noreferrer" : undefined}
        >
          {title}
        </a>
      );
    }
    if (item && item.new_tab) {
      return (
        <a
          key={key}
          className={className}
          href={route}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </a>
      );
    }
    return (
      <Link key={key} className={className} to={route}>
        {title}
      </Link>
    );
  };

  render() {
    const { t } = this.props;

    const {
      loading,
      activeProfile,
      loadingMainNav,
      mainNavigation,
      value,
      suggestions,
      loadingSuggesstion,
    } = this.state;
    const navItems = loadingMainNav
      ? []
      : mainNavigationItems(mainNavigation);

    if (this.state.playButtonClicked) {
      const returnToVideo = this.renderRedirectPage(
        this.state.videoDetailsFirst
      );

      if (returnToVideo != null) {
        return returnToVideo;
      }
    }

    return (
      <div className="user-header-sticky">
        <nav
          className="navbar navbar-expand navbar-dark main-nav"
          id="header"
        >
          <span
            className="menu-icon"
            id="menu_icon"
            onClick={() => this.toggleMobileSidebar()}
          >
            <img
              src={window.location.origin + "/assets/img/menu.png"}
              alt="menu_img"
            />
          </span>
          <Link className="navbar-brand abs" to="/home">
            <img
              src={configuration.get("configData.site_logo")}
              className="logo-img desktop-logo"
              alt={configuration.get("configData.site_name")}
            />
            <img
              src={configuration.get("configData.site_icon")}
              className="logo-img mobile-logo"
              alt={configuration.get("configData.site_name")}
            />
          </Link>
          <ul className="navbar-nav mobile-nav">
            {(() => {
              const compact =
                navItems.find((item) => item && item.feature_type === "browse") ||
                navItems.find(
                  (item) =>
                    item &&
                    item.type === "dropdown" &&
                    Array.isArray(item.children) &&
                    item.children.length > 0
                );
              return compact ? this.renderDesktopNavItem(compact) : null;
            })()}
          </ul>
          <ul className="navbar-nav desktop-nav ">
            {navItems.map((item) => this.renderDesktopNavItem(item))}
          </ul>
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <form
                className="search-suggestion-form"
                onSubmit={(event) => this.handleOnSubmit(event)}
              >
                <div className="search-input-container center">
                  <div className="search-input-container__inner">
                    <input
                      type="text"
                      name="search"
                      placeholder="Search"
                      value={value}
                      className={
                        "form-control search-form " +
                        this.state.searchInputFocusClass
                      }
                      onChange={this.handleSearchChange}
                      onClick={this.searchInputFocus}
                      autoComplete="off"
                    />
                    <div
                      className="suggestions-container center header-search-suggestions"
                      style={{
                        display: this.state.displaySuggesstion,
                      }}
                    >
                      <ul>
                        {loadingSuggesstion ? (
                          t("loading")
                        ) : (Array.isArray(suggestions) ? suggestions : [])
                            .length > 0 ? (
                          (Array.isArray(suggestions) ? suggestions : []).map(
                            (suggesstion, index) => (
                              <li
                                className=""
                                key={`suggestion-video/${index}`}
                                onClick={(event) =>
                                  this.handleSuggestionClick(event, suggesstion)
                                }
                              >
                                <span>
                                  {suggesstion.content_type === "channel"
                                    ? "[Live] "
                                    : ""}
                                  {suggesstion.title}
                                </span>
                              </li>
                            )
                          )
                        ) : (
                          <li className="" key="suggestion-no-result">
                            <span>{t("no_results_found")}</span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </form>
            </li>
            {getHeaderActions().map((action) => {
              const rawHref = action.href || action.internal_path || "#";
              const external = action.is_external || isExternalHref(rawHref);
              const href = external
                ? normalizeExternalUrl(rawHref)
                : rawHref;
              const openNewTab = !!action.open_in_new_tab;
              const aria = action.aria_label || action.label || action.key;
              let iconNode;
              if (action.icon_url) {
                iconNode = (
                  <img
                    src={action.icon_url}
                    alt=""
                    className="header-action-custom-icon"
                    style={{
                      width: "1.7em",
                      height: "1.7em",
                      objectFit: "contain",
                      verticalAlign: "middle",
                    }}
                  />
                );
              } else {
                const resolved =
                  resolveBrandLinkIconClass({
                    builtin_icon: action.icon,
                    icon_type: action.icon_type,
                    icon_url: action.icon_url,
                  }) || "fas fa-link";
                // Legacy header actions store icon as "fa-user-plus" without prefix.
                const iconClass =
                  resolved.indexOf("fa-") === 0 && resolved.indexOf(" ") === -1
                    ? `fas ${resolved} fa-icons`
                    : `${resolved} fa-icons`;
                iconNode = <i className={iconClass}></i>;
              }

              if (external) {
                return (
                  <li className="nav-item gift" key={`header-action-${action.key}`}>
                    <a
                      href={href}
                      className={`nav-link${action.css_class ? ` ${action.css_class}` : ""}`}
                      aria-label={aria}
                      title={action.label}
                      data-analytics-id={action.analytics_id || undefined}
                      target={openNewTab ? "_blank" : undefined}
                      rel={openNewTab ? "noopener noreferrer" : undefined}
                    >
                      {iconNode}
                    </a>
                  </li>
                );
              }

              return (
                <li className="nav-item gift" key={`header-action-${action.key}`}>
                  <Link
                    to={href}
                    className={`nav-link${action.css_class ? ` ${action.css_class}` : ""}`}
                    aria-label={aria}
                    title={action.label}
                    data-analytics-id={action.analytics_id || undefined}
                    target={openNewTab ? "_blank" : undefined}
                    rel={openNewTab ? "noopener noreferrer" : undefined}
                  >
                    {iconNode}
                  </Link>
                </li>
              );
            })}
            <UniversalCastButton />

            {localStorage.getItem("userId") &&
            localStorage.getItem("accessToken") ? (
              <NotificationBell />
            ) : null}

            {/* Account dropdown must remain visible on all breakpoints.
                Do not use `.mobile-view` — responsive.css hides that class on tablet.
                Anonymous public pages (org/creator/project) show Sign In instead. */}
            {localStorage.getItem("userId") &&
            localStorage.getItem("accessToken") ? (
              <li
                className="nav-item dropdown account-menu"
                data-tpg-header="UserHeader"
                data-tpg-build={
                  (typeof window !== "undefined" &&
                    window.__TPG_BUILD__ &&
                    window.__TPG_BUILD__.commit) ||
                  "unstamped"
                }
              >
                <Link
                  className="nav-link dropdown-toggle"
                  to="#"
                  data-toggle="dropdown"
                >
                  <img
                    src={localStorage.getItem("active_profile_image")}
                    className="nav-profile-img"
                    alt="profile_img"
                  />
                </Link>
                <div className="dropdown-menu profile-drop">
                  <div className="pro-sec-height">
                    {loading ? t("loading") : this.renderList(activeProfile)}

                    <Link className="dropdown-item" to="/view-profiles">
                      {t("view_profiles")}
                    </Link>
                  </div>
                  <p className="profile-drop-line" />
                  {Array.isArray(this.state.platformPortals) &&
                  this.state.platformPortals.length > 0 ? (
                    <React.Fragment>
                      <div className="ws-menu-label">Workspace</div>
                      {this.renderWorkspaceMenuItems()}
                      <p className="profile-drop-line" />
                    </React.Fragment>
                  ) : null}
                  <Link className="dropdown-item" to="/account">
                    {t("account")}
                  </Link>
                  <Link className="dropdown-item" to={"/logout"}>
                    {t("signout")}
                  </Link>
                </div>
              </li>
            ) : (
              <li
                className="nav-item account-menu"
                data-tpg-header="UserHeaderGuest"
              >
                <Link className="nav-link" to="/login">
                  {t("signin")}
                </Link>
              </li>
            )}
          </ul>
        </nav>
        <div className="header-height" />

        <div
          className="mobile-sidebar"
          id="menu_content"
          style={{
            display: this.state.mobileSidebar ? "block" : "none",
          }}
        >
          <div className="sidebar-content">
            <div className="p-3">
              <Link to="/view-profiles">
                <div className="display-inline">
                  <div className="left-sec">
                    <img
                      src={localStorage.getItem("active_profile_image")}
                      alt="User "
                    />
                  </div>
                  <div className="right-name">
                    <h5>{localStorage.getItem("active_profile_name")}</h5>
                    <h6>{t("switch_profiles")}</h6>
                  </div>
                </div>
              </Link>
            </div>
            <ul className="sidebar-menu" id="mobile-side-menu">
              <li className="active" key="account-sidemenu">
                <Link to="/account">{"account"}</Link>
              </li>
              {(this.state.platformPortals || []).map((portal) => (
                <li key={`portal-${portal.key || portal.role}`}>
                  <a
                    href={portal.path || "#"}
                    onClick={(e) => this.openPortal(portal, e)}
                  >
                    {portal.label || portal.role}
                  </a>
                </li>
              ))}
              <li key="logout-sidemenu">
                <Link to={"/logout"}>{t("logout")}</Link>
              </li>
              <li className="line" />
              {navItems.map((item) => this.renderMobileNavItem(item))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(withToastManager(translate(UserHeader)));
